export default __webpack_public_path__ + "static/media/cart-white.c945028f.svg";